/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:07/02/2021
 @Time:21:10
 **/
import TranslationService from "../../../i18n/service/TranslationService";
import LangueService from "../../../i18n/service/LangueService";
import CalculUtil from "../../util/CalculUtil";

export default class VenteLigneBase {

    /**
     * dernier numéro généré pour une ligne temporaire
     * @type={number}
     */
    static #_lastVenteLigneTemporaireIDGenere = 0;


    /**
     * @type{string}
     */
    #_id;

    /**
     * @type{boolean}
     */
    #_temporaire = true;

    /**
     * champ utilisé coté jackson pour désérialisation/sérialisation d'une entité java ayant des sous types(héritage)
     */
    #_discriminator

    /**
     * @type {number}
     */
    #_quantite = 0;

    /**
     *
     * @type {{}}
     */
    #_designations = {}

    /**
     * @type{number}
     */
    #_taxe = 0;

    /**
     * Prix hors taxes
     * @type{number}
     */
    #_prix = 0;


    /**
     * @type{Vente}
     */
    #_vente;

    /**
     *
     * @type {boolean}
     * @private
     */
    #_subventionne = false;


    /**
     * si le produit subventionne est contrôlé
     * @type {boolean}
     * @private
     */
    #_subventionneControle = false;


    get id() {
        return this.#_id;
    }

    set id(value) {
        this.#_id = value;
    }

    get quantite() {
        return this.#_quantite;
    }

    set quantite(value) {
        this.#_quantite = value;
    }

    get designations() {
        return this.#_designations;
    }

    set designations(value) {
        this.#_designations = value;
    }

    get taxe() {
        return this.#_taxe;
    }

    set taxe(value) {
        this.#_taxe = value;
    }

    get prix() {
        return this.#_prix;
    }

    set prix(value) {
        this.#_prix = value;
    }


    get discriminator() {
        return this.#_discriminator;
    }

    set discriminator(value) {
        this.#_discriminator = value;
    }


    get temporaire() {
        return this.#_temporaire;
    }

    set temporaire(value) {
        this.#_temporaire = value;
    }


    get subventionne() {
        return this.#_subventionne;
    }

    set subventionne(value) {
        this.#_subventionne = value;
    }

    get subventionneControle() {
        return this.#_subventionneControle;
    }

    set subventionneControle(value) {
        this.#_subventionneControle = value;
    }

    get vente() {
        return this.#_vente;
    }

    set vente(value) {
        this.#_vente = value;
    }

    /**
     * ajoute une traduction pour la désignation du produit pout produit article
     * @param {string} locale locale de la designation d'une ligne
     * @param designation désignation dans une langue spécifique
     */
    addDesignation(locale, designation) {
        this.#_designations[locale] = designation;
    }


    /**
     *
     * @param {string=} locale si on passe rien on retourne la designation dans langue active
     * @return {string}
     */
    getDesignation(locale = LangueService.getInstance().activeLangue.locale) {
        if (this.#_designations[locale] !== undefined) {
            return this.#_designations[locale];
        } else {
            return "";
        }
    }

    /**
     * retourne le prix totale d'une ligne TTC
     * @return {number}
     */
    getPrixTotaleTTC() {
        return this.getPrixTTC() * this.#_quantite;
    }

    /**
     *
     * @return {number}
     */
    getPrixTTC()
    {
        return CalculUtil.prixTTC(this.#_prix,this.#_taxe);
    }


    /**
     * retourne le prix d'un produit hors taxes
     * @return {number}
     */
    getPrixHTTC() {
        return this.#_prix;
    }

    /**
     * retourne le totale Hors taxes
     * @return {number}
     */
    getPrixTotaleHTTC() {
        return this.#_prix * this.quantite;
    }

    /**
     * Génère un nouveau Id temporaire pour une ligne vente et incrémente la numérotation
     * @return {string}
     */
    static generateIDTemporaire() {
        let idTemporaire = "vente-ligne-temporaire-" + VenteLigneBase.#_lastVenteLigneTemporaireIDGenere;
        VenteLigneBase.#_lastVenteLigneTemporaireIDGenere++;
        return idTemporaire;

    }

    /**
     *
     * @return {string} URL de suppression d'une ligne vente
     */
    getURLSuppression() {
        return this.#_temporaire ? null : Begro.getURL("vente/ligne-vente/" + this.id);
    }


    /**
     * méthode de classe qui permet de céer un nouveau objet vente ligne depuis un json généré depuis objet vente java
     * @param {{}} venteLigneJson
     * @param {VenteLigneBase} venteLigne
     * @returns {VenteLigneBase}
     */
    static createObjetFromJson(venteLigneJson, venteLigne) {
        venteLigne.quantite = venteLigneJson.quantite;
        venteLigne.taxe = venteLigneJson.taxe;
        venteLigne.prix = venteLigneJson.prix;
        venteLigne.subventionne = venteLigneJson.subventionne;
        venteLigne.subventionneControle = venteLigneJson.subventionneControle;
        if (venteLigneJson.id == null) {
            venteLigne.id = VenteLigneBase.generateIDTemporaire();
        } else {
            venteLigne.id = venteLigneJson.id;
            venteLigne.temporaire = false;
        }
        if (venteLigneJson.hasOwnProperty("traductions")) {
            for (let locale in venteLigneJson.traductions) {
                venteLigne.addDesignation(locale, venteLigneJson.traductions[locale].designation)
            }
        }
        return venteLigne;
    }


    getQuantiteDisponiblePourVente() {
        return 0;
    }

}